import { CollisionGroupManager } from 'excalibur';

// Create a group for each distinct category of "collidable" in your game
export const playerCollisionGroup = CollisionGroupManager.create(
  'player',
  0b00001110
);
export const npcCollisionGroup = CollisionGroupManager.create('npc', 0b0111);

export const tileCollisionGroup = CollisionGroupManager.create('tiles', 0b0011);

export const interactableCollisionGroup = CollisionGroupManager.create(
  'interactable',
  0b0001
);

// export const tileCollisionGroup = CollisionGroup.collidesWith([
//   playerCollisionGroup,
// ]);

// export const npcCollisionGroup = CollisionGroup.collidesWith([
//   playerCollisionGroup,
//   tileCollisionGroup,
// ]);
